/*
 |--------------------------------------------------------------------------
 | *map.js* NaviHelperClass
 |--------------------------------------------------------------------------
 |
 | Author: Stephan Schimpf
 | Date: 12.02.2014
 | Version: v0.01
 |
 */

import { Grid } from "./grid";

export const AjaxLoad = (function ($) {
  "use strict";

  /* =================== public methods ================== */

  // main init method
  function Init() {
    $(".ajax-more").click(function (e) {
      e.preventDefault();

      if (!$(this).hasClass("loading")) {
        $(this).addClass("loading");
        $(this).html($(this).attr("data-loading-text"));

        $.ajax({
          type: "GET",
          url: $(this).attr("href"),
        }).done(function (elem) {
          Grid.AddItems(elem);
          Init();
        });
      }
    });

    $(".ajax-more").each((index, button) => {
      const href = $(button).attr("href");
      $(button).hide();
      $.ajax({
        url: href,
        type: "get",
        statusCode: {
          404: function (response) {
            $(button).remove();
          },
        },
      }).done(function (data, statusText, xhr) {
        if (xhr.status !== 404) {
          $(button).show();
        }
      });
    });
  }

  /* =============== export public methods =============== */
  return {
    Init: Init,
  };
})(jQuery);
